import Vue from 'vue';

const vm = new Vue();
const prefixActionTaskName = 'globalActionTask';
const ADD_ACTION_TASK = 'addActionTask';
const REMOVE_ACTION_TASK = 'removeActionTask';

/**
 * 기능 수행 프로세스 객체
 * @author Ju
 */
export default class ActionProcess {
  /**
   * ActionProcess 생성자
   * @author Ju
   * @param  {object} store          store 객체 (required)
   * @param  {string} processName    기능 수행 프로세스명 (required)
   * @param  {object} params         기능 수행에 사용할 파라미터 객체 (optional)
   * @param  {boolean} autoComplete   자동 완료 여부. (defaeult: false).
   *                                  true이면 기능 수행 완료 후 컴포넌트 클릭 시 수행되는 function 수행 후 프로세스가 사라지도록 한다.
   * @param  {function} handleComplete 기능 수행 완료 후 컴포넌트 클릭 시 수행할 function
   * @param  {number} interval       기능 수행 주기 (required)
   * @param  {function} run            기능 수행 function (required)
   * @param  {number} repeat         기능 수행 반복 횟수 (optional)
   * @param  {[type]} repeatCallback 기능 수행 반복 완료 callback function (optional)
   */
  constructor(store, processName, params, autoComplete, handleComplete, interval, run, repeat, repeatCallback) {
    const createTime = new Date().getTime();
    this.processName = processName;
    this.taskName = `${prefixActionTaskName}-${createTime}`;
    this.params = params;
    this.createTime = createTime;
    this.autoComplete = autoComplete || false;
    this.progressRate = 0;
    this.isComplete = false;
    this.handleComplete = handleComplete;

    vm.$taskManager.createTask(this.taskName, interval, () => { run(this); }, true, repeat, () => { repeatCallback(this); });
    this.store = store;
    this.store.commit(ADD_ACTION_TASK, this);
  }
  /**
   * 기능 수행 프로세스명을 반환한다.
   * @author Ju
   * @return {string}
   */
  getProcessName() {
    return this.processName;
  }
  /**
   * 기능 수행 프로세스에 대한 task명을 반환한다. task명은 'globalActionTask' + Task 생성 시각이다.
   * @author Ju
   * @return {string}
   */
  getTaskName() {
    return this.taskName;
  }
  /**
   * 기능 수행 프로세스의 파라미터 객체를 반환한다.
   * @author Ju
   * @return {object}
   */
  getParams() {
    return this.params;
  }
  /**
   * 프로세스 생성 시각 정보를 반환한다.
   * @author Ju
   * @return {[type]} [description]
   */
  getCreateTime() {
    return this.createTime;
  }
  /**
   * 기능 수행 진행률을 설정한다.
   * @author Ju
   * @param  {number} progressRate
   */
  setProgressRate(progressRate) {
    this.progressRate = progressRate;
  }
  /**
   * 기능 수행 진행률을 반환한다.
   * @author Ju
   * @return {number}
   */
  getProgressRate() {
    return this.progressRate;
  }
  /**
   * 기능 수행 프로세스의 Task를 시작한다.
   * @author Ju
   */
  start() {
    vm.$taskManager.startTask(this.taskName);
  }
  /**
   * 기능 수행 완료 처리한다.
   * @author Ju
   */
  complete() {
    this.isComplete = true;
    vm.$taskManager.removeTask(this.getTaskName());

    if (this.autoComplete) {
      this.remove();
    }
  }
  /**
   * 기능 수행 프로세스를 제거한다.
   * @author Ju
   */
  remove() {
    this.store.commit(REMOVE_ACTION_TASK, this);
  }
  /**
   * 기능 수행 완료 후 수행할 hanlder를 호출한다.
   * @author Ju
   */
  completeAction() {
    this.handleComplete(this);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/action/ActionProcess.js